import type { ReactElement } from 'react';

import { Button } from '@spotify-internal/encore-web';
import { Tooltip, TooltipRoot } from '@spotify-internal/encore-web/next';
import { XirpIcon } from '@spotify/confidence-core-react';

import { buildCodeReviewXirpForSpotifyLaunchUrl } from './buildCodingSessionLaunchUrl';
import { navigateToUrl } from './navigateToUrl';
import { useXirpForSpotifySessionLaunchEnabled } from './useIssueLaunchRepositories';

type CodeReviewXirpForSpotifyActionProps = {
  pullRequestBranch: string;
  pullRequestNumber: number;
  pullRequestUrl: string;
  repositoryName: string;
  onLaunch: () => void;
};

export const CodeReviewXirpForSpotifyAction = ({
  onLaunch,
  ...props
}: CodeReviewXirpForSpotifyActionProps): ReactElement | null => {
  const isXirpForSpotifySessionLaunchEnabled =
    useXirpForSpotifySessionLaunchEnabled();

  if (!isXirpForSpotifySessionLaunchEnabled) {
    return null;
  }

  let launchUrl: string;
  try {
    launchUrl = buildCodeReviewXirpForSpotifyLaunchUrl(props);
  } catch {
    return (
      <TooltipRoot>
        <Button
          type="button"
          variant="secondary"
          aria-label="Open Xirp for Spotify unavailable"
          disabled
         data-track-source-anchor="dd7097025f">
          <XirpIcon size={16} />
          Open Xirp for Spotify
        </Button>
        <Tooltip>
          This pull request cannot be launched in Xirp for Spotify
        </Tooltip>
      </TooltipRoot>
    );
  }

  return (
    <Button
      type="button"
      variant="secondary"
      data-track-id="button.open-code-review-in-xirp-for-spotify"
      data-track-action="open"
      onClick={() => {
        onLaunch();
        navigateToUrl(launchUrl);
      }}
     data-track-source-anchor="3fcc619dbe">
      <XirpIcon size={16} />
      Open Xirp for Spotify
    </Button>
  );
};
